module.exports = __webpack_public_path__ + "static/media/BS_F_Timeless_Sforza_Orange.71fcdbc1.png";